<!-- 图片项组件 -->
<template>
  <div>
    <ItemCard :title="title" :index="index" :showRemove="showRemove" @remove-item="$emit('remove-item', $event)">
      <div>
        <div class="item-body">
          <div class="item-left">
            <p>
              <span>名称：</span>
              <span class="text">{{ value.url }}</span>
            </p>
            <p>
              <span>链接：</span>
              <el-tooltip effect="dark" :content="value.link" placement="top" v-if="value.link">
                <span class="text editable-link" @click="openLinkDialog">{{ value.link }}</span>
              </el-tooltip>
              <span v-else @click="openLinkDialog" class="link editable-link">请输入跳转链接</span>
            </p>
          </div>
          <div class="item-right">
            <div class="image-preview">
              <div class="image-box">
                <img :src="decodeURIComponent(value.url)">
                <span @click="$emit('edit-image', index)" class="el-icon-edit-outline"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-divider></el-divider>
      <div>
        <el-input type="textarea" rows="3" placeholder="请输入内容" v-model="value.text" show-word-limit>
        </el-input>
      </div>
    </ItemCard>

    <el-dialog title="请填写图片跳转链接" :visible.sync="linkDialogVisible" @close="closeLinkDialog" :z-index="9999">
      <el-form label-width="100px">
        <el-form-item label="跳转链接">
          <el-input v-model="linkUrl"></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="confirmLink">确定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import UploadImage from "@/components/Upload/UploadImage";
import ItemCard from "./ItemCard";
import editMixin from '../mixins/editMixin';

export default {
  name: 'ImageTextCard',
  mixins: [editMixin],
  components: {
    UploadImage,
    ItemCard
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    },
    showRemove: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: () => ({
        name: '',
        url: '',
        link: ''
      })
    }
  },
  data() {
    return {
      linkDialogVisible: false,
      linkUrl: ''
    }
  },
  methods: {
    openLinkDialog() {
      this.linkDialogVisible = true
      this.linkUrl = this.value.link || ''
    },
    closeLinkDialog() {
      this.linkDialogVisible = false
      this.linkUrl = ''
    },
    confirmLink() {
      this.updateValue({ link: this.linkUrl })
      this.closeLinkDialog()
    }
  },
}
</script>

<style lang="scss" scoped>
.item-body {
  display: flex;
  justify-content: space-between;
  gap: 16px;

  .item-left {
    font-size: 12px;
    flex: 1;
    width: 60%;

    p {
      margin: 12px 0 0;
      white-space: nowrap;
      overflow: hidden;
      display: flex;
      align-items: center;

      span:first-child {
        width: auto;
        flex-shrink: 0;
        font-weight: 500;
        color: #303133;
      }

      .text {
        white-space: nowrap;
        text-align: -webkit-auto;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #606266;
      }

      .link {
        color: #409eff;
        cursor: pointer;
        transition: all 0.3s ease;
        padding: 2px 4px;
        border-radius: 4px;

        &:hover {
          background: rgba(64, 158, 255, 0.1);
        }
      }

      .editable-link {
        cursor: pointer;

        &:hover {
          color: #409eff;
        }
      }
    }
  }

  .item-right {
    width: 40%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;

    .image-preview {
      .image-box {
        position: relative;
        width: 80px;
        height: 80px;
        border-radius: 4px;
        overflow: hidden;
        border: 1px solid #e4e7ed;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        span {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 20px;
          color: #fff;
          background: rgba(0, 0, 0, 0.5);
          padding: 8px;
          border-radius: 50%;
          cursor: pointer;
          opacity: 0;
          transition: all 0.3s ease;
        }

        &:hover span {
          opacity: 1;
        }
      }
    }
  }
}
</style>
